import {Component, OnInit, ViewChild} from '@angular/core';
import {PageDTO} from '../../../../../common/dtos/PageDTO';
import {Router} from '@angular/router';
import {Language} from '../../../../../common/models/language';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../../lang-change';
import {PaginationComponent} from '../../../../shared/components/pagination/pagination.component';
import {CenterCollegeService} from '../../../../../common_services/center-college.service';
import {CenterCollege} from './center-college';
import {MultiLang} from '../../../../admin/models/multiLang';
import {Utils} from '../../../../../common/services/Utils';
import {Principal} from '../../../../../common/services/principal';
import {ModuleENUM} from '../../../../../common/enums/module.enum';
import {ModuleExtendedEdit} from '../../../../../common/enums/module-extended-edit.enum';

@Component({
  selector: 'app-center-university',
  templateUrl: './center-college.component.html',
  styleUrls: ['./center-college.component.scss']
})
export class CenterCollegeComponent extends LangChange implements OnInit {

  langId: number;
  page: PageDTO;
  universityList: CenterCollege[];
  universityTypes: MultiLang[];
  universityForms: MultiLang[];
  universityStates: MultiLang[];
  creationTypes: MultiLang[];
  separatedUniversities: CenterCollege[];
  closeReasons: MultiLang[];
  hasWriteAccess = false;
  isAdmin = false;
  @ViewChild(PaginationComponent) child;

  constructor(protected _translateService: TranslateService,
              private _utils: Utils,
              private _principal: Principal,
              private centerCollegeService: CenterCollegeService,
              private  router: Router) {
    super(_translateService);
    this.langId = Language.getCurrentLanguage().id;
  }

  ngOnInit() {
    this.isAdmin = this._principal.isRegionAdmin() || this._principal.isAdmin();
    this.hasWriteAccess = this.isAdmin ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
    this.hasWriteAccess = true; // TODO Ubrat'
      this.page = new PageDTO();
    this.page.sorting = {};
    this.page.filter = {
      advanced: false,
      searchText: '',
      typeID: 0,
      creationTypeId: 0,
      formID: 0,
      stateID: 1,
      separatedUniversityId: 0,
      closeReasonId: 0
    };
    this.getDictionaries();
    this.load();
  }

  onEdit(id: number) {
    if (this.isAdmin) {
      this.router.navigate(['admin/dictionary/center-college/edit', id]);
    } else {
      this.router.navigate(['user/dictionary/center-college', id]);
    }
  }

  reloadBySort(p, v) {
    if (!v && this.page.sorting[this._utils.getLangSuff(p)]) {
      delete this.page.sorting[this._utils.getLangSuff(p)];
    }
    if (v) {
      this.page.sorting[this._utils.getLangSuff(p)] = v;
    }
    this.load();
  }

  load() {
    this.universityList = [];
    this.centerCollegeService.getCollegeList(this.page, this.langId).subscribe(
      data => {
        this.universityList = data.dtoList;
        this.page.totalElements = data.totalElements;
        this.changeUniversityListLang();
        if (this.page.pageNumber === 0 && this.child) {
          this.child.getPager();
        }
      }
    );
  }

  onLangChange(langCode): void {
    this.langId = langCode.id;
    this.changeUniversityListLang();
    Language.updateListLocalizedName(this.universityForms);
    Language.updateListLocalizedName(this.universityTypes);
    Language.updateListLocalizedName(this.universityForms);
    Language.updateListLocalizedName(this.creationTypes);
    Language.updateListLocalizedName(this.separatedUniversities);
    Language.updateListLocalizedName(this.closeReasons);

  }

  changeUniversityListLang() {
    if (this.universityList) {
      for (let i = 0; i < this.universityList.length; i++) {
        Language.updateLocalizedName(this.universityList[i]);
        Language.updateLocalizedName(this.universityList[i].type);
        Language.updateLocalizedName(this.universityList[i].state);
        Language.updateLocalizedName(this.universityList[i].form);
        Language.updateLocalizedName(this.universityList[i].cato);
      }
    }
  }

  getDictionaries() {
    this.centerCollegeService.getTypes().subscribe(
      data => {
        this.universityTypes = data;
        Language.updateListLocalizedName(this.universityTypes);
      }
    );
    this.centerCollegeService.getForms().subscribe(
      data => {
        this.universityForms = data;
        Language.updateListLocalizedName(this.universityForms);
      }
    );
    this.centerCollegeService.getStates().subscribe(
      data => {
        this.universityStates = data;
        Language.updateListLocalizedName(this.universityStates);
      }
    );
    this.centerCollegeService.getCreationTypes().subscribe(
      data => {
        this.creationTypes = data;
        Language.updateListLocalizedName(this.creationTypes);
      }
    );
    this.centerCollegeService.getAllSeparated().subscribe(
      data => {
        this.separatedUniversities = data;
        Language.updateListLocalizedName(this.separatedUniversities);
      }
    );
    this.centerCollegeService.getCloseReasons().subscribe(
      data => {
        this.closeReasons = data;
        Language.updateListLocalizedName(this.closeReasons);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/university/center-college.component.ts